import dynamic from 'next/dynamic';
import { PreferredPaymentInfoProps } from './PreferredPaymentInfo.types';

export const PreferredPaymentInfo = dynamic<{ model: PreferredPaymentInfoProps }>(() =>
  import('./PreferredPaymentInfo').then(mod => mod.PreferredPaymentInfo)
);
